<form>
   <div class="sam-form-row">
      <label class="k-radio-label" for="showProgressbar">
         <input
            type="radio"
            id="showProgressbar"
            [checked]="showProgressbar$ | async"
            class="k-radio"
            kendoRadioButton
            name="progressionOption"
            (click)="changeShowProgressbar($event.currentTarget.checked)"
         />
         {{ 'brick.brick_definitions.presence_duration.settings.show_progressbar' | translate }}
      </label>
      <label class="k-radio-label" for="showText">
         <input
            type="radio"
            id="showText"
            [checked]="showDurationAsText$ | async"
            class="k-radio"
            kendoRadioButton
            name="progressionOption"
            (click)="changeShowDurationAsText($event.currentTarget.checked)"
         />
         {{ 'brick.brick_definitions.presence_duration.settings.show_duration_text' | translate }}
      </label>
   </div>
</form>
